import veraGlass from "../svg/vera-glass.svg";
import React from "react";
import './Logo.css'

export default function Logo() {
    return <div className="logo">
        <img src={veraGlass} alt="vera-tiles-logo"/>
    </div>;
}